module.exports = __webpack_public_path__ + "img/personal_site_screenshot.e88756b2.jpg";